<ion-card
  mode="ios"
  color="getm-neutral-white"
  class="card-body-detail-product"
>
  <!-- * Caso 1: Promoción Estática -->
  <ng-container
    *ngIf="promoData && promoData.ClavePromo; else productOrLoading"
  >
    <ion-list mode="ios" class="list-content">
      <!-- ! Información principal de la promoción -->
      <ion-item
        mode="md"
        color="transparent"
        lines="none"
        class="item-product-info"
      >
        <ion-label color="getm-neutral-light" class="label-product-info">
          <ion-text class="product-title" color="getm-neutral-dark">
            {{ promoData.Promocion }}
          </ion-text>
        </ion-label>
      </ion-item>

      <!-- ! Puntos y Etiquetas de Descuento -->
      <ion-item
        mode="md"
        color="transparent"
        lines="none"
        class="item-product-pricing"
      >
        <ng-container
          *ngTemplateOutlet="coinsBadge; context: { item: promoData }"
        ></ng-container>

        <section slot="end" class="col-price ion-no-padding">
          <getm-promo-tag-sale [promo]="promoData"></getm-promo-tag-sale>
        </section>
      </ion-item>

      <!-- ! Acciones Promoción -->
      <section class="actions">
        <ion-grid class="actions-grid ion-no-padding">
          <ion-row class="ion-justify-content-between ion-align-items-center">
            <!-- Columna Izquierda: Estado / Disponibilidad / Advertencias -->
            <ion-col size="5">
              <ng-container
                *ngIf="
                  promoData.MaximoPaquetes - promoData.PaquetesCanjeados > 0;
                  else promoSoldOut
                "
              >
                <ng-container
                  *ngTemplateOutlet="promoAvailability"
                ></ng-container>
              </ng-container>

              <ng-template #promoSoldOut>
                <ng-container
                  *ngIf="
                    quantity >= 1 && (quantityExtras$ | async) > 0;
                    else limitReachedTpl
                  "
                >
                  <ng-container
                    *ngTemplateOutlet="swiperTemplate"
                  ></ng-container>
                </ng-container>
                <ng-template #limitReachedTpl>
                  <ng-container
                    *ngTemplateOutlet="
                      warningCard;
                      context: { text: ('Labels.limit-reached' | translate) }
                    "
                  ></ng-container>
                </ng-template>
              </ng-template>
            </ion-col>

            <!-- Columna Derecha: Botón Agregar o Selector de Cantidad -->
            <ion-col size="6.7">
              <ng-container *ngIf="quantity < 1; else promoQuantitySelector">
                <getm-button
                  [text]="'Buttons.add' | translate"
                  color="primary"
                  size="default"
                  expand="block"
                  [disabled]="
                    promoData.MaximoPaquetes - promoData.PaquetesCanjeados <= 0
                  "
                  (btnClick)="onBuildPromo()"
                ></getm-button>
              </ng-container>

              <ng-template #promoQuantitySelector>
                <getm-quantity-selector
                  [quantity]="quantity"
                  [minimo]="1"
                  [maximo]="
                    promoData.Productos?.length === 1
                      ? ('RangeSelector.Store.end' | translate)
                      : promoData.MaximoPaquetes
                  "
                  [showRemoveBtn]="true"
                  fill="solid"
                  (quantityChange)="onQuantityChangePromo($event)"
                  (removeProduct)="onRemovePromo()"
                ></getm-quantity-selector>
              </ng-template>
            </ion-col>
          </ion-row>
        </ion-grid>
      </section>
    </ion-list>
  </ng-container>

  <!-- * Caso 2: Producto o Loading -->
  <ng-template #productOrLoading>
    <ng-container
      *ngIf="product && product.clave_producto; else loadingTemplate"
    >
      <ion-list mode="ios" class="list-content">
        <!-- ! Información principal del producto -->
        <ion-item
          mode="md"
          color="transparent"
          lines="none"
          class="item-product-info"
        >
          <ion-label color="getm-neutral-light" class="label-product-info">
            <ion-text class="product-title" color="getm-neutral-dark">
              {{ product.title }}
            </ion-text>
            <ion-text class="product-unit" color="getm-neutral-light">
              {{ product.subtitle }}
            </ion-text>
            <ion-text class="product-detail" color="getm-neutral-light">
              {{ 'Labels.taste' | translate }}:&nbsp;{{ product.sku }}
            </ion-text>
            <ion-text class="product-detail" color="getm-neutral-light">
              {{ 'Labels.sku' | translate }}:&nbsp;{{ product.clave_producto }}
              <ng-container *ngIf="!isProd">
                &nbsp;{{ 'Labels.factorcl' | translate }}:
                {{ product.FactorCl }}
              </ng-container>
            </ion-text>
          </ion-label>
        </ion-item>

        <!-- ! Puntos y Precio -->
        <ion-item
          mode="md"
          color="transparent"
          lines="none"
          class="item-product-pricing"
        >
          <ng-container
            *ngTemplateOutlet="coinsBadge; context: { item: product }"
          ></ng-container>

          <section slot="end" class="col-price ion-no-padding">
            <getm-price-display
              [price]="product.precio"
              [discount]="product.precio_original"
            ></getm-price-display>
          </section>
        </ion-item>

        <!-- ! Acciones Producto -->
        <section
          [ngClass]="{
            actions:
              !!(product.pendientes_cajas_sio === 0) || product.productos > 0
          }"
        >
          <ng-container *ngIf="product.productos < 1; else selectorQuantity">
            <ng-container
              *ngIf="
                !product.pendientes_cajas_sio ||
                  product.pendientes_cajas_sio === 0;
                else withSuggested
              "
            >
              <getm-button
                [text]="'Buttons.add' | translate"
                color="primary"
                size="default"
                expand="block"
                (btnClick)="onQuantityChange(1)"
              ></getm-button>
            </ng-container>
            <ng-template #withSuggested>
              <ion-grid class="actions-grid ion-no-padding">
                <ion-row
                  class="ion-justify-content-between ion-align-items-center"
                >
                  <ion-col size="5">
                    <getm-left-label-card
                      class="suggested-label"
                      [text]="
                        'Labels.suggested-products'
                          | translate
                            : {
                                quantity: product.pendientes_cajas_sio
                              }
                      "
                    ></getm-left-label-card>
                  </ion-col>
                  <ion-col size="6.7">
                    <getm-button
                      [text]="'Buttons.add' | translate"
                      color="primary"
                      size="default"
                      expand="block"
                      (btnClick)="onQuantityChange(1)"
                    >
                    </getm-button>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ng-template>
          </ng-container>

          <ng-template #selectorQuantity>
            <getm-quantity-selector
              [quantity]="product.productos"
              [minimo]="1"
              [maximo]="'RangeSelector.Store.end' | translate"
              fill="solid"
              (quantityChange)="onQuantityChange($event)"
              (removeProduct)="onRemoveProduct()"
            ></getm-quantity-selector>
          </ng-template>
        </section>
      </ion-list>
    </ng-container>

    <ng-template #loadingTemplate>
      <ion-skeleton-text animated class="loading-product"></ion-skeleton-text>
    </ng-template>
  </ng-template>
</ion-card>

<!-- ? Swiper de advertencias -->
<ng-template #swiperTemplate>
  <section class="section-swiper-container">
    <ion-grid class="ion-no-padding component-slider-box">
      <section
        class="slider-wrapper"
        [style.transform]="'translateY(-' + activeSlide * 50 + '%)'"
      >
        <ion-row class="slide-item">
          <ion-col size="12">
            <ng-container
              *ngTemplateOutlet="
                warningCard;
                context: {
                  text:
                    'Labels.packages-added-without-discount'
                    | translate : { quantityExtras: (quantityExtras$ | async) }
                }
              "
            ></ng-container>
          </ion-col>
        </ion-row>

        <ion-row class="slide-item">
          <ion-col size="12">
            <ng-container
              *ngTemplateOutlet="
                warningCard;
                context: { text: ('Labels.limit-reached' | translate) }
              "
            ></ng-container>
          </ion-col>
        </ion-row>
      </section>
    </ion-grid>
  </section>
</ng-template>

<!-- ? Disponibilidad y Vigencia de Promoción -->
<ng-template #promoAvailability>
  <getm-left-label-card
    [text]="
      'Labels.available-and-ends-v2'
        | translate
          : {
              available:
                promoData.MaximoPaquetes - promoData.PaquetesCanjeados,
              ends: promoData.Vigencia
            }
    "
  ></getm-left-label-card>
</ng-template>

<!-- ? Tarjeta de advertencia genérica -->
<ng-template #warningCard let-text="text">
  <getm-left-label-card
    icon="getm-warning-fill"
    iconColor="getm-warning-default"
    [text]="text"
    colorBg="getm-warning-light"
  ></getm-left-label-card>
</ng-template>

<!-- ? Badge de puntos compartido -->
<ng-template #coinsBadge let-item="item">
  <ng-container
    *ngIf="item.puntos_recompepsi || item.muestra_texto_generico_puntos"
  >
    <section slot="start" class="col-coins ion-no-padding">
      <getm-coins-badge
        [size]="item.muestra_texto_generico_puntos ? 'small' : 'large'"
        [text]="
          item.muestra_texto_generico_puntos
            ? ('Labels.earn-points' | translate)
            : '+' + item.puntos_recompepsi
        "
      ></getm-coins-badge>
    </section>
  </ng-container>
</ng-template>
